import React from 'react';
import { CustomizedTypography } from '@components/Customized';
import { colorSet, clsx } from '@components/Provider';
import { Box, makeStyles } from '@material-ui/core';
import RequiredDot from '@components/RequiredDot';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

interface CreateOrderCommonInputBoxProps {
  className?: string;
  label: string;
  labelIcon?: React.ReactNode;
  input: React.ReactNode;
  require?: boolean;
  style?: CSSProperties;
}

const CreateOrderCommonInputBox: React.FC<CreateOrderCommonInputBoxProps> = ({
  className,
  label,
  labelIcon,
  input,
  require = false,
  style
}) => {
  const { commonInputContainer } = useCreateOrderCommonInputBoxStyles();

  return (
    <Box style={style} className={clsx([commonInputContainer, className])}>
      <Box className="labelBox">
        <CustomizedTypography variant={'body1'}>{label}</CustomizedTypography>
        {require && <RequiredDot />} {labelIcon}
      </Box>
      <Box className="input">{input}</Box>
    </Box>
  );
};

export default CreateOrderCommonInputBox;

const useCreateOrderCommonInputBoxStyles = makeStyles((theme) => ({
  commonInputContainer: {
    width: '100%',
    '& .labelBox': {
      flex: 1,
      display: 'flex',
      gap: '6px',
      alignItems: 'center',
      marginBottom: 12,
      '& svg': {
        fill: colorSet.gray600,
        width: 20,
        height: 20
      }
    },
    '& .input': {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-end',
      gap: '8px',
      '& input::placeholder': {
        color: colorSet.gray500,
        opacity: 1
      }
    },
    '& .MuiOutlinedInput-root': {
      height: 48,
      '&.MuiOutlinedInput-adornedStart': {
        whiteSpace: 'nowrap'
      }
    }
  }
}));
